
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Playground } from 'docz';
import PropsTable from './docs/PropsTable';
import { COMMON, TYPOGRAPHY } from './docs/system_props';
import { Text } from './Text';

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "text"
    }}>{`Text`}</h1>
    <Playground __position={0} __code={'<Text>Some text</Text>'} __scope={{
      props: this ? this.props : props,
      Playground,
      PropsTable,
      COMMON,
      TYPOGRAPHY,
      Text
    }} __codesandbox={`undefined`} mdxType="Playground">
  <Text mdxType="Text">Some text</Text>
    </Playground>
    <h3 {...{
      "id": "props"
    }}>{`Props`}</h3>
    <PropsTable mdxType="PropsTable">
  {[{
        name: 'as',
        description: 'Sets the HTML tag',
        type: 'String',
        defaultValue: 'span'
      }, ...COMMON, ...TYPOGRAPHY]}
    </PropsTable>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;